import React from 'react'
import hash from 'object-hash'
import { RegisterUserInvitedView, ContractView } from '../../views'
import { ClientService, Auth0Service, LocalStorageService, UserService, AddressService, ContractService, DownloadSignaturesService, MessageService } from '../../../services'
import { ValidateInputPure, MessagePure, SimpleLoading, UserInvitedInformationPure } from '../../pures'

import { PersonalInformation, PhoneValidation, TermsCondition } from '../../../assets/logos/icons'
import { useTranslation } from "react-i18next"

import { RegisterInvitedValidator } from '../../../validators'
import ChangePasswordAction from '../change-password/change-password.action'
import { formatPhoneNumber } from 'react-phone-number-input'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import InvitedWoutPasswordAction from '../InvitedWoutPassword/InvitedWoutPassword.action'

class RegisterUserInvitedAction extends React.Component {
    constructor(props) {
        super(props)
    }
    input = React.createRef()

    state = {
        userId: '',
        clientId: '',
        userTypeId: '',
        languageId: '',
        email: '',
        contractBullets: [],
        loading: true,
        planChecked: false,
        showNotification: false,
        showLoadingRequesting: false,
        showCompletedRequesting: false,
        showErrorRequesting: false,
        redirectToChangePass: false,
        termnsAndConditions: false,
        modalTermsCond: false,
        step: 0,
        selectedStep: 0,
        invitedSteps: [
            { icon: PersonalInformation, itemElement: this.props.t('register.user.invited.action.personalInformationTitle'), itemSup: 'register.user.invited.action.nextLabel', key: 'register.personalData', labelreturn: 'register.user.invited.action.close', label: 'register.user.invited.action.personalData' },
            { icon: PhoneValidation, itemElement: this.props.t('registration.action.validation'), itemSup: 'registration.action.Steps.nextLaber', key: 'register.address', labelreturn: 'registration.action.Steps.backLaber', label: 'messagePure.validation' },
            { icon: TermsCondition, itemElement: this.props.t('register.user.invited.action.tos'), itemSup: 'register.user.invited.action.nextLabel', key: this.props.t('register.user.invited.action.tos'), labelreturn: 'register.user.invited.action.backLabel', itemMoral: 'register.user.invited.action.nextLabel', label: 'register.user.invited.action.tos' },
        ],
        logo: null,
        validationCode: '',
        validationCodeCorrect: false,
        focused: false,
        eventId: '',
        accountId: 0,
        userUpdated: null,
        isDownloadSignaturesData: false,
        donwloadLoading: false,
        isLastStep: false,
        logo: null,
        cellphoneNumber: '',
        redirectSignRequest: false,
        withoutPasswordSign: false,
        flags: [
            {
                language: 'es',
                src: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_LANGUAGE_MX}`,
                label: 'ES',
                status: true
            },
            {
                label: '|',
                status: false
            },
            {
                language: 'en',
                src: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_LANGUAGE_US}`,
                label: 'EN',
                status: false
            }
        ]
    }

    token = {}
    user = {}
    url = process.env.REACT_APP_MIFIRMA_API
    localStorageService = new LocalStorageService()
    auth0Service = new Auth0Service()
    userService = new UserService(this.url)
    downloadSignaturesService = new DownloadSignaturesService(this.url)
    clientService = new ClientService(this.url)
    messageService = new MessageService(this.url)

    contractService = new ContractService(this.url)
    addressService = new AddressService(this.url)
    validator = RegisterInvitedValidator(this.props.t)
    invitedStepMetadata = [
        { number: 0, component: UserInvitedInformationPure },
        { number: 1, component: MessagePure },
        { number: 2, component: ContractView, action: 'validateContract' },
    ]
    enabledSMS = false

    /**
     * @author Martín Sánchez
     * @description Check if the contract is selected
     */
    validateContract = async () => {
        if (!this.state.termnsAndConditions) {
            await this.toggleErrorRequesting(true, this.props.t('register.user.invited.action.messageAcceptTos'))
            return false
        } else if (this.state.userTypeId === Number(process.env.REACT_APP_USER_TYPE_ADMINISTRADOR) && !this.state.planChecked) {
            await this.toggleErrorRequesting(true, this.props.t('register.user.invited.action.messagePlaseConfirm'))
            return false
        } else {
            return true
        }
    }

    componentDidMount = async () => {
        let contractBullets
        let userInformation
        let userInformationAkubicaFirmaDigital

        let language = this.localStorageService.getLocalStorageItem("preferredLanguage")

        this.setFlags(language)
        if (!this.props.withoutPasswordSign) {
            this.token = this.localStorageService.getLocalStorageItem('token').idToken
            this.user = this.localStorageService.getLocalStorageItem('user')

            contractBullets = await this.contractService.getContractBullets(this.token)

            userInformation = this.user.userMetaData.userA3Cloud
            userInformationAkubicaFirmaDigital = this.user.userMetaData.userMifirma
            await this.localStorageService.setLocalStorageItem('clientLogo', '')
            let logo = await this.fetchClientImage()
            await this.localStorageService.setLocalStorageItem('clientLogo', logo ? logo : '')

            this.enabledSMS = this.user && this.user && this.user.userMetaData && this.user.userMetaData.enabledSMS
            let steps
            if (!this.enabledSMS) {
                steps = [...this.state.invitedSteps]
                let stepsMetadata = [...this.invitedStepMetadata]
                let foundStep = steps.findIndex(item => item.label === "messagePure.validation")
                steps.splice(foundStep, 1)
                stepsMetadata.splice(foundStep, 1)
                this.invitedStepMetadata = stepsMetadata
            }
            let languageId = userInformationAkubicaFirmaDigital.language.isokey
            let language = this.localStorageService.getLocalStorageItem("preferredLanguage")
            if (language) languageId = language
            return this.setState({
                userId: userInformation.id,
                userTypeId: userInformationAkubicaFirmaDigital.userType.id,
                languageId,
                clientId: userInformation.clientId,
                email: userInformation.email,
                contractBullets,
                loading: false,
                invitedSteps: steps ?? this.state.invitedSteps
            })

        } else {
            let steps = [...this.state.invitedSteps], stepsMetadata = [...this.invitedStepMetadata]
            let foundStep = steps.findIndex(item => item.label === this.props.t("messagePure.validation"))
            steps.splice(foundStep, 1)
            stepsMetadata.splice(foundStep, 1)

            this.user = this.localStorageService.getLocalStorageItem('user')
            this.invitedStepMetadata = stepsMetadata
            return this.setState({

                // userId: userInformation.id,
                // userTypeId: userInformationAkubicaFirmaDigital.userType.id,
                // languageId: userInformationAkubicaFirmaDigital.language.id,
                // clientId: userInformation.clientId,
                invitedSteps: steps,
                email: this.props.userEmail,
                contractBullets,
                loading: false,
                withoutPasswordSign: true
            })
        }

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.termnsAndConditions !== this.state.termnsAndConditions) {
            if (this.state.termnsAndConditions) {
                let eventId = hash({ hash: Math.random().toString(36).substring(7) })
                this.setState({ eventId })
            }
        }
    }

    /**
    * @author Alan Aguilar
    * @description Method to show the loading dialog modal
    * @date 22-10-2020
    * @memberof RegisterUserInvitedAction
    */
    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        })
    }

    openModalTermsCond = (value) => {
        this.setState({
            modalTermsCond: value
        });
    }

    openModalPolicityPrivacy = (value) => {
        this.setState({
            modalPolicityPrivacy: value
        });
    }

    async fetchClientImage() {
        let result = await this.clientService.getClientImage(this.token)
        return result?.data?.image
    }
    onAcceptTermnsAndConditions = () => this.setState({ termnsAndConditions: !this.state.termnsAndConditions })
    onAcceptPlan = () => this.setState({ planChecked: !this.state.planChecked })

    /**
    * @author Alan Aguilar
    * @description Method to show the complete request dialog modal
    * @date 22-10-2020
    * @memberof RegisterUserInvitedAction
    */
    toggleCompletedRequesting = (value, message) => {
        this.setState({
            showCompletedRequesting: value,
            messageComplete: message
        },
            () => {
                setTimeout(() => {
                    this.setState({
                        showCompletedRequesting: false,
                    })
                }, 4000)
            }
        )
    }

    /**
    * @author Alan Aguilar
    * @description Method to show the Error request dialog modal
    * @date 22-10-2020
    * @memberof RegisterUserInvitedAction
    */
    toggleErrorRequesting = (value, message) => {
        this.setState({
            showErrorRequesting: value,
            message: message
        },
            () => {
                setTimeout(() => {
                    this.setState({
                        showErrorRequesting: false,
                    })
                }, 4000)
            })
    }

    /**
* @author Alan Aguilar
* @description Method to show the WARNING dialog modal
* @memberof SignatureRequestAction
*/
    toggleWarningRequesting = (value, message) => {
        this.setState({
            showWarningRequesting: value,
            message: message
        },
            () => {
                setTimeout(() => {
                    this.setState({
                        showWarningRequesting: false,
                    })
                }, 4000)
            })
    }


    /**
     * @author Martín Sánchez
     * @description Close the modal after some time
     */
    handleMessage = () => {
        setTimeout(() => {
            this.onCloseOpenModal()
        }, 15000);
    }

    /**
     * @author Martín Sánchez
     * @description Close/Open the modal
     */
    onCloseOpenModal = () => this.setState({ showNotification: !this.state.showNotification })

    changeStepNumber = (step) => {
        let stepLenght = this.state.invitedSteps.length - 1
        step = (step >= stepLenght) ? stepLenght : step + 1
        return step
    }

    /**
    * @author Alan Aguilar
    * @description Method to clear the localStorage and close the sesion
    * @date 22-10-2020
    * @memberof RegisterUserInvitedAction
    */
    onCloseSesion = async () => {
        let logo = await this.localStorageService.getLocalStorageItem('clientLogo')
        await this.localStorageService.clearLocalStorage()
        await this.localStorageService.setLocalStorageItem('clientLogo', logo ? logo : '')
        this.auth0Service.logout()
    }

    onBackStep = async (event) => {
        event.preventDefault()
        let stepNumber = this.stepBack(this.state.selectedStep)
        this.setState({ selectedStep: stepNumber })
    }
    stepBack = (step) => {
        if (this.state.loading && step === 0) {
            this.setState({ selectedPersonType: false })
        } else if (step === 0) {
            this.setState({ selectedPersonType: false })
            this.handleButtonLogOut()
        } else {
            step = step - 1
        }
        return step
    }
    handleButtonLogOut = async () => {
        let logo = await this.localStorageService.getLocalStorageItem('clientLogo')
        await this.localStorageService.clearLocalStorage()
        await this.localStorageService.setLocalStorageItem('clientLogo', logo ? logo : '')
        this.auth0Service.logout()
    }

    onCellphoneChange = (cellphone) => {
        if (cellphone) {
            this.setState({
                cellphoneNumber: cellphone
            })
        }
    }


    /**
    * @author Alan Aguilar
    * @description Hanlde method submit to make the petition in Mifirma-api
    * @date 22-10-2020
    * @memberof RegisterUserInvitedAction
    */
    onSubmitRegisterUserInvited = async (dataItem) => {
        let selectedStep = this.state.selectedStep
        if (!this.enabledSMS && this.invitedStepMetadata.length !== (selectedStep + 1)) {
            let stepNumber = this.changeStepNumber(selectedStep)
            return this.setState({ selectedStep: stepNumber })
        }
        this.user = this.localStorageService.getLocalStorageItem('user')
        let stepNumber = this.changeStepNumber(selectedStep)
        let action = this.invitedStepMetadata[selectedStep].action
        let result = true
        if (action) { // Only when the submit step requires an action the result is evaluated
            result = await this[action](dataItem)
            this.handleMessage()
        }

        if (result) { // When result its ok, we can flow to next steps
            if (selectedStep === 0 && !this.props.withoutPasswordSign) {
                let phoneNumber = dataItem.cellphoneNumber || this.state.cellphoneNumber
                let newPhoneNumber = phoneNumber.replace("+", "");
                let message = await this.messageService.sendMessage(
                    newPhoneNumber,
                    false,
                    this.user.userToken ? this.user.userToken.name : this.props.email
                );
                if (message.statusCode !== 200) {
                    await this.toggleWarningRequesting(true, message.message);
                    return false;
                }
            }
            if ((selectedStep === 1 && !this.props.withoutPasswordSign && this.enabledSMS)) {
                if (this.state.validationCode.length !== 6) {
                    this.toggleWarningRequesting(
                        true,
                        'El código no cumple con la cantidad de carácteres necesarios.'
                    )
                    return
                }
                let validationCode = this.state.validationCode
                let codeValidator = await this.messageService.validateMessage(
                    validationCode,
                    this.user.userToken ? this.user.userToken.name : this.props.email,
                    this.token
                );

                if (codeValidator.data) {
                    this.setState({
                        validationCodeCorrect: true
                    })
                } else {
                    await this.toggleWarningRequesting(true, 'Teléfono o mensaje Incorrectos.')
                    return false
                }
            } else if ((selectedStep === 1 && this.props.withoutPasswordSign && result)) {
                try {
                    await this.toggleLoadingRequesting(true)
                    let {
                        firstName,
                        secondLastName,
                        street,
                        externalNumber,
                        zipCode,
                        state,
                        firstLastName,
                        phoneNumber,
                        colony,
                        internalNumber,
                        township,
                        country,
                        rfc
                    } = dataItem

                    let {
                        clientId,
                        userTypeId,
                        languageId,
                        eventId,
                        termnsAndConditions,
                        cellphoneNumber
                    } = this.state

                    // Validate opcional data
                    cellphoneNumber = (cellphoneNumber === undefined || cellphoneNumber === '') ? ' ' : cellphoneNumber
                    phoneNumber = (phoneNumber === undefined || phoneNumber === '') ? ' ' : phoneNumber
                    let newCellPhoneNumber = formatPhoneNumber(cellphoneNumber)
                    let newPhoneNumber = formatPhoneNumber(phoneNumber)
                    street = (street === undefined || street === '') ? ' ' : street
                    externalNumber = (externalNumber === undefined || externalNumber === '') ? ' ' : externalNumber
                    internalNumber = (internalNumber === undefined || internalNumber === '') ? ' ' : internalNumber
                    zipCode = (zipCode === undefined || zipCode === '') ? '00000' : zipCode
                    colony = (colony === undefined || colony === '') ? ' ' : colony
                    township = (township === undefined || township === '') ? ' ' : township
                    state = (state === undefined || state === '') ? ' ' : state
                    country = (country === undefined || country === '') ? ' ' : country
                    rfc = (rfc === undefined || rfc === '') ? ' ' : rfc

                    if (!this.props.withoutPasswordSign) {
                        this.token = this.localStorageService.getLocalStorageItem('token').idToken
                    }

                    //Update the user information and the addressId
                    //let addressId = addressUpdate.data.address.data.id
                    // this.setState({ userUpdated, isLastStep: true })
                    let userData = {
                        firstName,
                        clientId,
                        addressId: process.env.INVITED_ADDRESS_ID,
                        firstLastName,
                        secondLastName,
                        phoneNumber: newPhoneNumber,
                        cellphoneNumber: newCellPhoneNumber,
                        countryCodePhone: phoneNumber,
                        countryCodeCellphone: cellphoneNumber,
                        userTypeId,
                        languageId,
                        rfc,
                        termnsAndConditions,
                        accountId: process.env.ACCOUNT_ID,
                        eventId
                    }
                    let userUpdated
                    if (this.props.withoutPasswordSign) userData.email = this.props.email
                    if (!this.props.withoutPasswordSign) userUpdated = await this.userService.updateUser(userData, this.token)
                    else userUpdated = await UserService.updateUserPublic(userData, this.props.signToken)

                    this.setState({ userUpdated, isLastStep: true })
                    if (!(Number(userUpdated.statusCode) === 200)) throw new Error('No se puedo completar la peticion')
                    await this.toggleLoadingRequesting(false)
                    await this.toggleCompletedRequesting(true)

                    if (this.props.withoutPasswordSign) {
                        userUpdated = { userA3Cloud: userUpdated.data.userA3CloudUpdate.data, userMifirma: userUpdated.data.userMiFirma }
                        this.localStorageService.setLocalStorageItem("user", userUpdated)
                        this.setState({ redirectToChangePass: true, redirectSignRequest: true })
                    }
                    else this.setState({ redirectSignRequest: true })
                    return {
                        firstName,
                        secondLastName,
                        street,
                        externalNumber,
                        zipCode,
                        state,
                        firstLastName,
                        phoneNumber,
                        cellphoneNumber,
                        colony,
                        internalNumber,
                        township,
                        country,
                        rfc
                    }
                } catch (error) {
                    this.setState({ selectedStep: 1 })
                    await this.toggleLoadingRequesting(false)
                    await this.toggleErrorRequesting(true)
                    return false
                }
            } else if (selectedStep === 2 && result || (selectedStep === 1 && !this.enabledSMS && result)) { // If we are in the last step then we save the data

                try {
                    await this.toggleLoadingRequesting(true)
                    let {
                        firstName,
                        secondLastName,
                        street,
                        externalNumber,
                        zipCode,
                        state,
                        firstLastName,
                        phoneNumber,
                        colony,
                        internalNumber,
                        township,
                        country,
                        rfc
                    } = dataItem

                    let {
                        clientId,
                        userTypeId,
                        languageId,
                        eventId,
                        termnsAndConditions,
                        cellphoneNumber
                    } = this.state

                    // Validate opcional data
                    cellphoneNumber = (cellphoneNumber === undefined || cellphoneNumber === '') ? ' ' : cellphoneNumber
                    phoneNumber = (phoneNumber === undefined || phoneNumber === '') ? ' ' : phoneNumber
                    let newCellPhoneNumber = formatPhoneNumber(cellphoneNumber)
                    let newPhoneNumber = formatPhoneNumber(phoneNumber)
                    street = (street === undefined || street === '') ? ' ' : street
                    externalNumber = (externalNumber === undefined || externalNumber === '') ? ' ' : externalNumber
                    internalNumber = (internalNumber === undefined || internalNumber === '') ? ' ' : internalNumber
                    zipCode = (zipCode === undefined || zipCode === '') ? '00000' : zipCode
                    colony = (colony === undefined || colony === '') ? ' ' : colony
                    township = (township === undefined || township === '') ? ' ' : township
                    state = (state === undefined || state === '') ? ' ' : state
                    country = (country === undefined || country === '') ? ' ' : country
                    rfc = (rfc === undefined || rfc === '') ? ' ' : rfc

                    if (!this.props.withoutPasswordSign) {
                        this.token = this.localStorageService.getLocalStorageItem('token').idToken
                    }

                    //Update the user information and the addressId
                    //let addressId = addressUpdate.data.address.data.id
                    // this.setState({ userUpdated, isLastStep: true })
                    let userData = {
                        firstName,
                        clientId,
                        addressId: process.env.INVITED_ADDRESS_ID,
                        firstLastName,
                        secondLastName,
                        phoneNumber: newPhoneNumber,
                        cellphoneNumber: newCellPhoneNumber,
                        countryCodePhone: phoneNumber,
                        countryCodeCellphone: cellphoneNumber,
                        userTypeId,
                        languageId,
                        rfc,
                        termnsAndConditions,
                        accountId: process.env.ACCOUNT_ID,
                        eventId
                    }
                    let userUpdated
                    if (this.props.withoutPasswordSign) userData.email = this.props.email
                    if (!this.props.withoutPasswordSign) userUpdated = await this.userService.updateUser(userData, this.token)
                    else userUpdated = await UserService.updateUserPublic(userData, this.props.signToken)

                    this.setState({ userUpdated, isLastStep: true })
                    if (!(Number(userUpdated.statusCode) === 200)) throw new Error('No se puedo completar la peticion')
                    await this.toggleLoadingRequesting(false)
                    await this.toggleCompletedRequesting(true)

                    if (this.props.withoutPasswordSign) {
                        userUpdated = { userA3Cloud: userUpdated.data.userA3CloudUpdate.data, userMifirma: userUpdated.data.userMiFirma }
                        this.localStorageService.setLocalStorageItem("user", userUpdated)
                        this.setState({ redirectToChangePass: true, redirectSignRequest: true })
                    }
                    else this.setState({ redirectSignRequest: true })
                    return {
                        firstName,
                        secondLastName,
                        street,
                        externalNumber,
                        zipCode,
                        state,
                        firstLastName,
                        phoneNumber,
                        cellphoneNumber,
                        colony,
                        internalNumber,
                        township,
                        country,
                        rfc
                    }
                } catch (error) {
                    this.setState({ selectedStep: 1 })
                    await this.toggleLoadingRequesting(false)
                    await this.toggleErrorRequesting(true)
                    return false
                }
            }

            this.setState({ selectedStep: stepNumber })
        }
    }


    onReSendMessage = async (event, validationType) => {
        event.preventDefault();
        let phoneNumber = this.state.cellphoneNumber;
        let newPhoneNumber = phoneNumber.replace("+", "");
        let message = this.messageService.reSendMessage(newPhoneNumber, validationType, this.user.userToken ? this.user.userToken.name : this.props.email, this.token);

        if (validationType === 'phoneNumber') {
            await this.toggleCompletedRequesting(true, this.props.t("registration.action.resendMessageSMS"));
        } else if (validationType === 'mail') {
            await this.toggleCompletedRequesting(true, this.props.t("registration.action.resendMessageEmail"));
        }

        return message;
    };

    //Button Validate input
    handleClick = () => {
        this.input.current.focus()
    }

    handleFocus = () => {
        this.setState({ focused: true })
    }

    handleBlur = () => {
        this.setState({
            focused: false,
        })
    }

    handleChange = (e) => {
        const validationCode = e.target.value
        const CODE_LENGTH = new Array(6).fill(0)

        this.setState((state) => {
            if (state.validationCode.length >= CODE_LENGTH.length) return null
            return {
                validationCode: (state.validationCode + validationCode).slice(0, CODE_LENGTH.length),
            }
        })
    }

    handleKeyUp = (e) => {
        if (e.key === "Backspace") {
            this.setState((state) => {
                return {
                    validationCode: state.validationCode.slice(0, state.validationCode.length - 1),
                }
            })
        }
    }

    setFlags = (language) => {
        if (!language) return
        let flags = this.state.flags.map((flag) => {
            flag.status = (language === flag.language) ? true : false
            return flag
        })

        this.setState({
            flags
        })
    }

    render() {
        if (this.state.loading) {
            return <SimpleLoading />
        } else {
            if (!this.state.redirectToChangePass && !this.state.redirectSignRequest) {
                return (
                    <RegisterUserInvitedView
                        {...this.state}
                        setFlags={this.setFlags}
                        enabledSMS={this.enabledSMS}
                        isLastStep={this.state.isLastStep}
                        goToApp={async () => {
                            await this.toggleCompletedRequesting(true)
                            this.setState({ redirectToChangePass: true })
                        }}
                        validator={this.validator}
                        validateInput={ValidateInputPure}
                        onSubmitRegisterUserInvited={this.onSubmitRegisterUserInvited}
                        onCloseSesion={this.onCloseSesion}
                        onChangeUserPassword={this.onChangeUserPassword}
                        onAcceptTermnsAndConditions={this.onAcceptTermnsAndConditions}
                        contractBullets={this.state.contractBullets}
                        toggleLoadingRequesting={this.toggleLoadingRequesting}
                        toggleCompletedRequesting={this.toggleCompletedRequesting}
                        toggleErrorRequesting={this.toggleErrorRequesting}
                        toggleWarningRequesting={this.toggleWarningRequesting}
                        steps={this.state.invitedSteps}
                        onAcceptPlan={this.onAcceptPlan}
                        onChangeStep={this.onChangeStep}
                        stepMetadata={this.invitedStepMetadata}
                        onSubmitClick={this.onSubmitClick}
                        onBackStep={this.onBackStep}
                        openModalTermsCond={this.openModalTermsCond}
                        openModalPolicityPrivacy={this.openModalPolicityPrivacy}
                        donwloadLoading={this.donwloadLoading}

                        onReSendMessage={this.onReSendMessage}
                        handleClick={this.handleClick}
                        handleFocus={this.handleFocus}
                        handleBlur={this.handleBlur}
                        handleChange={this.handleChange}
                        handleKeyUp={this.handleKeyUp}

                        input={this.input}
                        onCellphoneChange={this.onCellphoneChange}

                    />
                )
            } else if (this.state.redirectToChangePass && this.state.redirectSignRequest) {
                return <InvitedWoutPasswordAction id={this.props.idSign} email={this.props.email} />
            } else {
                return (<ChangePasswordAction
                    {...this.state}
                />)
            }
        }
    }
}

function RegisterUserInvitedActionContainer(props) {
    const { t } = useTranslation()
    return (
        <RegisterUserInvitedAction {...props} t={t} />
    )
}


export { RegisterUserInvitedActionContainer as default }